import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import {
  psCreateOrder, psGetOrder, psAddService, psRemoveService,
  psAddItem, psDeleteItem, psDeleteOrder, psGetQuote, psSetPricingAddress,
} from "../lib/psApi";

export const usePsStore = create(
  persist(
    (set, get) => ({
      orderId: null,
      order: null,
      quote: null,
      history: [],

      ensureOrder: async () => {
        const { orderId } = get();
        if (orderId) {
          try {
            const o = await psGetOrder(orderId);
            set({ order: o });
            return o;
          } catch { /* recreate below */ }
        }
        const created = await psCreateOrder();
        set({ orderId: created.id, order: created });
        return created;
      },

      refresh: async () => {
        const { orderId } = get();
        if (!orderId) return;
        try { set({ order: await psGetOrder(orderId) }); } catch { /* ignore */ }
        await get().refreshQuote();
      },
      refreshQuote: async () => {
        const { orderId } = get();
        if (!orderId) { set({ quote: null }); return; }
        try { set({ quote: await psGetQuote(orderId) }); } catch { /* ignore */ }
      },

      setPricingAddress: async (body) => {
        const o = await get().ensureOrder();
        const q = await psSetPricingAddress(o.id, body);
        set({ quote: q });
        await get().refresh();
        return q;
      },

      addService: async (stop) => { const o = await get().ensureOrder(); await psAddService(o.id, stop); await get().refresh(); },
      removeService: async (stop) => { const { orderId } = get(); if (!orderId) return; await psRemoveService(orderId, stop); await get().refresh(); },
      addItem: async (stop, body) => { const o = await get().ensureOrder(); await psAddItem(o.id, stop, body); await get().refresh(); },
      deleteItem: async (stop, itemId) => { const { orderId } = get(); if (!orderId) return; await psDeleteItem(orderId, stop, itemId); await get().refresh(); },
      reset: async () => { const { orderId } = get(); if (orderId) { try { await psDeleteOrder(orderId); } catch { /* ignore */ } } set({ orderId: null, order: null, quote: null }); },

      hasService: (stop) => !!get().order?.sub_orders?.some((s) => s.stop_type === stop),

      recordPlaced: () => {
        const o = get().order;
        if (!o?.id || !o.track_token || !o.order_number) return;
        const existing = get().history.filter((h) => h.order_id !== o.id);
        set({ history: [{ order_id: o.id, order_number: o.order_number, track_token: o.track_token, placed_at: new Date().toISOString() }, ...existing] });
      },
      removeFromHistory: (orderId) => set({ history: get().history.filter((h) => h.order_id !== orderId) }),
    }),
    { name: "labase-ps-web", storage: createJSONStorage(() => localStorage), partialize: (s) => ({ orderId: s.orderId, history: s.history }) }
  )
);
